var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "sidebar", attrs: { id: "sidebar-wrapper" } }, [
    _c(
      "ul",
      {
        staticClass: "sidebar-nav nav-pills nav-stacked",
        attrs: { id: "menu" }
      },
      [
        _c(
          "li",
          { ref: "dashboard", attrs: { id: "dashboard" } },
          [
            _c(
              "router-link",
              {
                staticClass: "menu-icon dashboard-icon",
                attrs: { to: { name: "Dashboard" } }
              },
              [_vm._v("\r\n                Dashboard\r\n            ")]
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35a79c62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35a79c62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Sidebar.vue
// module id = null
// module chunks = 